import type { EnvName } from './config.types';

export function getDomainEnv(): EnvName {
  if (globalThis.window !== undefined) {
    const hostname = globalThis.window.location?.hostname;

    if (hostname.includes('localhost')) {
      return 'dev';
    }

    if (hostname.includes('dev')) {
      return 'dev';
    }

    if (hostname.includes('staging')) {
      return 'staging';
    }
  }

  return 'prod';
}

export const getSafeStringNumber = (value?: string): number | null => {
  if (value === undefined || value === null) return null;
  const num = Number(value);

  return Number.isFinite(num) ? num : null;
};
